import TextRender from 'components/Global/TextRender/TextRender';
import { IPatternError } from 'interfaces/requestAQuote';
import React, { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { useStyles } from './TextField.styles';

export interface ITextFieldProps {
  label: string;
  name: string;
  dataAutomation?: string;
  isRequired?: string;
  pattern?: IPatternError | null;
  error?: string;
  maxLength?: number;
  defaultValue?: string;
  type?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export function TextField({
  label,
  name,
  dataAutomation,
  isRequired,
  pattern,
  error,
  maxLength,
  defaultValue,
  type,
  onChange,
}: ITextFieldProps): JSX.Element {
  const classes = useStyles();
  const methods = useFormContext();
  const { register } = methods ? methods : { register: undefined };
  const zipcodeRegex = /^\d{5}$/;
  const newPattern =
    pattern?.value && pattern.value === '[zipcode]'
      ? zipcodeRegex
      : pattern?.value;

  return (
    <div id="text-input" className={classes.container}>
      <label className={`acr-paragraph-9 t-label`}>
        {label}
        {isRequired && <span className={classes.required_tag}>*</span>}
      </label>
      {register ? (
        <input
          {...register(name, {
            required: isRequired,
            pattern: {
              message: pattern?.message || '',
              value: new RegExp(newPattern || ''),
            },
          })}
          type={type}
          name={name}
          data-automation={dataAutomation}
          aria-label={label}
          className={classes.input}
          maxLength={maxLength || undefined}
          required={isRequired ? true : false}
          defaultValue={defaultValue}
          onChange={onChange}
        />
      ) : (
        <input
          name={name}
          className={classes.input}
          maxLength={maxLength || undefined}
          required={isRequired ? true : false}
          defaultValue={defaultValue}
          onChange={onChange}
        />
      )}

      {error && (
        <p className={`acr-paragraph-8 t-error_text ${classes.error_text}`}>
          <TextRender text={error} />
        </p>
      )}
    </div>
  );
}
